import api from './api';

export const todosService = {
  /**
   * Fetch todos with filters and pagination
   */
  fetchTodos: async (filters = {}, pagination = {}) => {
    const params = {
      page: pagination.page || 1,
      per_page: pagination.perPage || 20,
      status: filters.status !== 'all' ? filters.status : undefined,
      priority: filters.priority !== 'all' ? filters.priority : undefined,
      search: filters.search || undefined,
      sort: filters.sortBy || 'created_at',
      order: filters.sortOrder || 'desc'
    };

    const response = await api.get('/todos', { params });
    // Backend returns { success: true, data: { todos, page, per_page, total } }
    return {
      data: response.data.data.todos,
      page: response.data.data.page,
      per_page: response.data.data.per_page,
      total: response.data.data.total
    };
  },

  /**
   * Get single todo by ID
   */
  getTodo: async (todoId) => {
    const response = await api.get(`/todos/${todoId}`);
    return response.data.data;
  },

  /**
   * Update todo
   */
  updateTodo: async (todoId, updates) => {
    const response = await api.patch(`/todos/${todoId}`, updates);
    return response.data.data;
  },

  /**
   * Delete todo
   */
  deleteTodo: async (todoId) => {
    const response = await api.delete(`/todos/${todoId}`);
    return response.data;
  },

  /**
   * Create manual todo
   */
  createTodo: async (todoData) => {
    const response = await api.post('/todos', todoData);
    return response.data.data;
  }
};
